import { combineReducers } from 'redux';
import authentication from './modules/auth';
import survey from './modules/survey';
import report from './modules/report';
import organization from './modules/organization';
import activity from './modules/activity';
import extra from './modules/extra';
import user from './modules/user';
import admin from './modules/admin';
import sidebar from './modules/sidebar';
import audit from './modules/audit';
import reportBuilder from './modules/reportBuilder';

const reducers = combineReducers({
  authentication,
  survey,
  report,
  organization,
  activity,
  extra,
  user,
  admin,
  sidebar,
  audit,
  reportBuilder,
});

export default reducers;
